import type { ReactNode } from 'react';

export function Labeled({
  label,
  required,
  children,
}: {
  label: string;
  required?: boolean;
  children: ReactNode;
}) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 5, fontSize: 12, minWidth: 0 }}>
      <span style={{ color: 'var(--fg-3)' }}>
        {label}
        {required ? ' *' : ''}
      </span>
      {children}
    </label>
  );
}

export function SectionTitle({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        fontSize: 12,
        fontWeight: 600,
        color: 'var(--fg-2)',
        marginBottom: 8,
        textTransform: 'uppercase',
        letterSpacing: 0,
      }}
    >
      {children}
    </div>
  );
}

export function Card({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: 12,
        border: '1px solid var(--border-1)',
        borderRadius: 'var(--r-2)',
        background: 'var(--bg-1)',
        minWidth: 0,
      }}
    >
      {children}
    </div>
  );
}

export function CardRow({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  );
}

export function FieldGrid({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 10,
      }}
    >
      {children}
    </div>
  );
}
